import React, { useEffect, useState } from "react";

import {
  GRANTED,
  DENIED,
  alreadyRestored,
  applyConsent,
  readStoredConsent,
  writeStoredConsent,
} from "../../utils/consent";

/**
 * First-visit consent prompt.
 *
 * Restoring a SAVED decision is not this component's job any more — the
 * inline snippet in public/index.html does that synchronously in <head>,
 * before gtm.js loads, because a decision applied after the tags have
 * fired is worthless (the visit is already recorded cookieless). See
 * src/utils/consent.js for the full reasoning.
 *
 * What's left here is the case the snippet cannot handle: there is no
 * stored decision yet, so only a click can produce one.
 */
const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = readStoredConsent();

    if (stored) {
      // Normally the inline snippet already pushed this decision. It only
      // fails to when localStorage threw in <head> but works now, so
      // re-apply as a backstop — and skip it when the snippet succeeded,
      // to avoid pushing a second identical consent update.
      if (!alreadyRestored()) applyConsent(stored);
      return;
    }

    setVisible(true);
  }, []);

  const decide = (decision) => {
    writeStoredConsent(decision);
    // The update has to reach the Google tag, not just dismiss the UI —
    // hiding the banner without this leaves the visitor permanently in
    // the default denied state.
    applyConsent(decision);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-text">
        We use cookies to analyze site usage and improve your experience. You
        can accept all cookies or decline non-essential ones.
      </div>
      <div className="cookie-banner-actions">
        <button
          type="button"
          className="cookie-banner-btn decline"
          onClick={() => decide(DENIED)}
        >
          Decline
        </button>
        <button
          type="button"
          className="cookie-banner-btn accept"
          onClick={() => decide(GRANTED)}
        >
          Accept all
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
